import request from '@/utils/request';

// 获取AI语音助手技能提示列表
export function deskPromptList(options) {
  return request({
    url: `/op/deskPrompt/pageList`,
    method: 'get',
    params: options
  });
}

// 发布AI语音助手技能提示
export function deskPromptAdd(options) {
  return request({
    url: `/op/deskPrompt/add`,
    method: 'post',
    data: options
  });
}

// 修改AI语音助手技能提示
export function deskPromptUp(options) {
  return request({
    url: `/op/deskPrompt/update/${options.id}`,
    method: 'post',
    data: options
  });
}

// 删除AI语音助手技能提示
export function deskPromptDel(options) {
  return request({
    url: `/op/deskPrompt/delete/${options.id}`,
    method: 'delete',
    data: options
  });
}
